import type { CreateThemedStyleFunc } from './types';

/**
 * This is just a helper function to create a themed style factory with typing.
 */
const createThemedStyle: CreateThemedStyleFunc = (factory) => factory;

export default createThemedStyle;
